import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc23d2fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history-list" }
const _hoisted_2 = { class: "history-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "history-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-icon" }, "📋"),
  /*#__PURE__*/_createTextVNode(" 扫描记录 ")
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "clear-icon" }, "🗑️", -1 /* HOISTED */))
const _hoisted_5 = { class: "history-items" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "history-content" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "history-meta" }
const _hoisted_10 = { class: "history-time" }
const _hoisted_11 = { class: "history-type" }
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "history-arrow" }, "›", -1 /* HOISTED */))
const _hoisted_14 = {
  key: 0,
  class: "empty-history"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, "📭", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-text" }, "暂无扫描记录", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-hint" }, "扫码后将显示在这里", -1 /* HOISTED */))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "clear-btn",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('clear'))),
        title: "清空历史"
      }, [
        _hoisted_4,
        _createTextVNode(" 清空 ")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.history, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id || index,
          class: _normalizeClass(["history-item", { failed: item.status === 'failed' }]),
          onClick: $event => (_ctx.$emit('item-click', item))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["history-icon", item.type])
          }, _toDisplayString($setup.getTypeIcon(item.type)), 3 /* TEXT, CLASS */),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "history-value",
              title: item.value
            }, _toDisplayString($setup.truncate(item.value, 35)), 9 /* TEXT, PROPS */, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString($setup.formatTime(item.time)), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_11, _toDisplayString(item.type), 1 /* TEXT */),
              (item.message)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "history-msg",
                    title: item.message
                  }, _toDisplayString($setup.truncate(item.message, 25)), 9 /* TEXT, PROPS */, _hoisted_12))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _hoisted_13
        ], 10 /* CLASS, PROPS */, _hoisted_6))
      }), 128 /* KEYED_FRAGMENT */)),
      ($props.history.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_18))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}